<div class="rsd-backdrop" (click)="close()"></div>
<div class="rsd-dialog" role="dialog" aria-modal="true" [attr.aria-label]="title">
    <div class="rsd-head">
        <div>
            <h5 class="mb-0">{{ title }}</h5>
            <small class="text-muted" *ngIf="subtitle">{{ subtitle }}</small>
        </div>
        <button type="button" class="rsd-x" aria-label="Close" (click)="close()">&times;</button>
    </div>
    <div class="rsd-body">
        <p class="small text-muted" *ngIf="message">{{ message }}</p>
        <label class="small mb-1" for="rsd-reason">Reason <span class="text-danger">*</span></label>
        <textarea id="rsd-reason" rows="3" class="form-control form-control-sm" [(ngModel)]="reason"
                  [ngModelOptions]="{standalone: true}" placeholder="Saved in the registration's history"></textarea>
        <small class="text-danger" *ngIf="reasonMissing">Please give a reason for the change.</small>
    </div>
    <div class="rsd-error" *ngIf="error" role="alert">{{ error }}</div>
    <div class="rsd-foot">
        <button type="button" class="btn btn-light btn-sm" (click)="close()" [disabled]="busy">Cancel</button>
        <button type="button" class="rana-action-btn rana-action-btn-success" (click)="submit()" [disabled]="busy">{{ confirmLabel }}</button>
    </div>
</div>
